// const baseurl = "https://www.onekbc.org";
const baseurl = process.env.REACT_APP_API_URL || "http://localhost:8000";
export default baseurl;

